import { render, staticRenderFns } from "./updateRow.vue?vue&type=template&id=248ef6d1"
import script from "./updateRow.vue?vue&type=script&lang=js"
export * from "./updateRow.vue?vue&type=script&lang=js"
import style0 from "./updateRow.vue?vue&type=style&index=0&id=248ef6d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports